
document.addEventListener('DOMContentLoaded', function() {
  var button = document.querySelector('.btn-vermas');
  
  button.addEventListener('click', function() {
    var moreText = document.querySelector('.more-text');
    
    // Si el texto está oculto, mostrarlo
    if (moreText.style.display === "none" || moreText.style.display === "") {
      moreText.style.display = "block";
      button.innerHTML = "Ver menos"; 
    } else {
      moreText.style.display = "none";
      button.innerHTML = "Ver más"; 
    }
  });
});
